import React, { useState } from 'react';
import styles from './RemoveUserCard.module.css';
import { axiosInstance } from '../../../../../Authentication/AxiosInterceptor';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ClientUserDisplayInfoWithRoles } from '../../../../../Types/ClientUserDisplayInfo';
import ConfirmAction from '../../../ConfirmAction/ConfirmAction';
//Components
//Data

type RemoveUserCardProps = {
    user: ClientUserDisplayInfoWithRoles;
    handleRemoveUserFromList: (user: ClientUserDisplayInfoWithRoles) => void;
    areaId?: string;
    disabled?: boolean;
    onRemove?: (user: ClientUserDisplayInfoWithRoles) => Promise<void>;
    membershipLabel?: string;
};

const RemoveUserCard = ({ user, handleRemoveUserFromList, areaId: propAreaId, disabled = false, onRemove, membershipLabel = "area" } : RemoveUserCardProps) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const { areaId: paramAreaId } = useParams();
  const areaId = propAreaId || paramAreaId;

  const handleRemoveUser = async () => {
    try {
      if (onRemove) await onRemove(user);
      else await axiosInstance.put(`RemoveProductUser/${areaId}/${user.sub}`);
      handleRemoveUserFromList(user);
      toast.success(`User ${user.fullName} removed successfully!`);
    } catch (error) {
      console.error('Error removing user:', error);
      toast.error(`Failed to remove user ${user.fullName}. Please try again.`);
    }
  };

  const handleConfirmRemove = async () => {
    await handleRemoveUser();
    setShowConfirm(false);
  };

  return (
    <>
      <div className={styles.container}>
        <p>{user.fullName}</p>


        <div className={styles.roles}>
        {user.roles?.map((role) => (
          <span key={role} className={styles.role}>
            {role}
          </span>
        ))}
        </div>

              <span onClick={() => !disabled && setShowConfirm(true)}>
          <img src={'/img/minus.svg'} alt="Remove user" />
        </span>
      </div>

      <ConfirmAction
        isVisible={!disabled && showConfirm}
        onClose={() => setShowConfirm(false)}
        clickHandler={handleConfirmRemove}
        title="Confirm Remove User"
        message={`Are you sure you want to remove ${user.fullName} from this ${membershipLabel}?`}
        severity="danger"
        icon="/img/minus.svg"
      />
    </>
  );
};

export default RemoveUserCard;